import { createApi } from '@reduxjs/toolkit/query/react';

import axiosBaseQuery from '../network/axiosBaseQuery';

const baseApiSlice = createApi({
  reducerPath: '$api',
  baseQuery: axiosBaseQuery(),
  endpoints: () => ({}),
});

export default baseApiSlice;
